import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { Badge } from '../ui/Badge';

interface AuthShellProps {
  title: string;
  sub: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
}

const TrustStat: React.FC<{ value: string; label: string }> = ({ value, label }) => (
  <div>
    <div style={{ fontSize: 24, fontWeight: 600, color: '#fff' }}>{value}</div>
    <div style={{ fontSize: 12, color: '#9a9fb8' }}>{label}</div>
  </div>
);

export const AuthShell: React.FC<AuthShellProps> = ({ title, sub, children, footer }) => {
  const { translate } = useLanguage();

  return (
    <div className="auth-shell">
      {/* Left pane — form slot */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 32,
        }}
      >
        <div style={{ width: '100%', maxWidth: 400 }}>
          <h1 style={{ fontSize: 28, letterSpacing: '-0.02em', margin: 0 }}>{title}</h1>
          <p className="muted" style={{ marginTop: 6, marginBottom: 0 }}>{sub}</p>
          <div style={{ marginTop: 28 }}>{children}</div>
          {footer && (
            <div style={{ marginTop: 24, fontSize: 14, color: 'var(--ink-3)' }}>
              {footer}
            </div>
          )}
        </div>
      </div>

      {/* Right pane — marketing */}
      <div className="auth-side">
        {/* Radial gradient overlay */}
        <div
          style={{
            position: 'absolute',
            inset: 0,
            background:
              'radial-gradient(circle at 80% 20%, rgba(25, 198, 230, 0.2), transparent 60%)',
          }}
        />

        {/* Top content */}
        <div style={{ position: 'relative' }}>
          <Badge tone="cyan">{translate('auth-badge')}</Badge>
          <h2
            style={{
              fontSize: 36,
              marginTop: 24,
              marginBottom: 0,
              letterSpacing: '-0.02em',
              lineHeight: 1.15,
              color: '#fff',
            }}
          >
            {translate('auth-headline')}
            <br />
            <span
              style={{
                fontFamily: 'var(--font-disp)',
                fontStyle: 'italic',
                fontWeight: 400,
              }}
            >
              {translate('auth-headline-italic')}
            </span>
          </h2>
          <p style={{ marginTop: 16, color: '#cfd1e4', maxWidth: 380 }}>
            {translate('auth-marketing-body')}
          </p>
        </div>

        {/* Trust stats */}
        <div style={{ position: 'relative', display: 'flex', gap: 24 }}>
          <TrustStat value="98.6%" label={translate('trust-on-time')} />
          <TrustStat value="2.4M" label={translate('trust-shipments')} />
          <TrustStat value="24/7" label={translate('trust-support')} />
        </div>
      </div>
    </div>
  );
};

export default AuthShell;
